import { useTranslations } from "@zapier/i18n";
import { useAccountActionPermissions } from "@zapier/client";
import { BetaPageHeader } from "@zapier/design-system";
import {
  DefaultViewButton,
  HeaderButton,
  OwnerFilter,
  SearchInput,
  useRouterParams,
} from "@zapier/shared";
import { AssetTypes, CHATBOT_CREATE_ROUTE } from "@zapier/utils";
import { useCallback } from "react";
import { SharingFilter } from "./Filters/SharingFilter";
import { ChatbotsPlanInfo } from "./ChatbotsPlanInfo";

import styles from "./ChatbotsHeader.module.css";

interface ChatbotsHeaderProps {
  showFilters?: boolean;
}

export function ChatbotsHeader({ showFilters = true }: ChatbotsHeaderProps) {
  const t = useTranslations("chatbots-header");

  const { isChatbotsEnabled } = useAccountActionPermissions();

  const { setParams } = useRouterParams();
  const { allowTeams } = useAccountActionPermissions();

  const search = useCallback(
    (searchValue: string) => {
      setParams({ search: searchValue }, ["page"]);
    },
    [setParams],
  );

  return (
    <BetaPageHeader
      title={t("title")}
      actions={
        <div className={styles.actions}>
          <ChatbotsPlanInfo />
          <HeaderButton
            icon="formAdd"
            href={CHATBOT_CREATE_ROUTE}
            buttonText={t("buttons.create")}
            tooltipContent={
              isChatbotsEnabled
                ? t("buttons.create-tooltip")
                : t("buttons.create-disabled-tooltip")
            }
            buttonColor="primary"
            iconButtonColor="primary"
            isDisabled={!isChatbotsEnabled}
          />
        </div>
      }
      additionalContent={
        showFilters ? (
          <div className={styles.root}>
            <SearchInput
              placeholder={t("search.placeholder")}
              onSearch={search}
            />

            <div className={styles.sharing}>
              <SharingFilter />
            </div>

            {allowTeams && (
              <div className={styles.ownerFilter}>
                <OwnerFilter
                  assetType={AssetTypes.Chatbot}
                  isLabelHidden={true}
                />
              </div>
            )}

            <DefaultViewButton />
          </div>
        ) : undefined
      }
    />
  );
}
